import { calculateNetStock, calculateDOI, getTrafficLight } from './calculations';

const STORAGE_KEY = 'aeg_inventory_snapshot';

export const aiAnalyst = {
    // Main Entry Point
    analyze: (currentData) => {
        const previousData = aiAnalyst.loadSnapshot();

        if (!previousData) {
            return null; // First run, nothing to compare
        }

        const insights = aiAnalyst.compare(previousData, currentData);
        return insights;
    },

    saveSnapshot: (data) => {
        try {
            // We only need SKU, stock, sales, classification for comparison
            // Minifying to save space if needed, but for <500 items full obj is fine.
            const snapshot = data.map(item => ({
                SKU: item.SKU,
                Description: item.Description,
                PhysicalStock: item.PhysicalStock,
                OnOrder: item.OnOrder,
                AvgDailySales: item.AvgDailySales,
                Classification: item.Classification
            }));
            localStorage.setItem(STORAGE_KEY, JSON.stringify(snapshot));
            localStorage.setItem(STORAGE_KEY + '_date', new Date().toISOString());
        } catch (e) {
            console.error("Failed to save snapshot", e);
        }
    },

    loadSnapshot: () => {
        try {
            const data = localStorage.getItem(STORAGE_KEY);
            return data ? JSON.parse(data) : null;
        } catch (e) {
            return null;
        }
    },

    compare: (oldData, newData) => {
        const changes = [];
        const oldMap = new Map(oldData.map(i => [i.SKU, i]));

        newData.forEach(newItem => {
            const oldItem = oldMap.get(newItem.SKU);
            if (!oldItem) return; // New item, ignore for now or handle separately

            // Calculate Metrics
            const oldNet = calculateNetStock(oldItem);
            const newNet = calculateNetStock(newItem); // Using default logic (no forecast factor for comparison)

            // 1. Restock Alert (Was <= 0, Now > 0)
            if (oldNet <= 0 && newNet > 0) {
                changes.push({
                    sku: newItem.SKU,
                    desc: newItem.Description,
                    type: 'RESTOCKED',
                    message: 'חזר למלאי',
                    priority: 'HIGH',
                    details: `מלאי קודם: ${oldNet} -> חדש: ${newNet}`
                });
            }

            // 2. Low Stock Alert (Was > 30, Now < 30 but > 0)
            else if (oldNet >= 30 && newNet < 30 && newNet > 0) {
                changes.push({
                    sku: newItem.SKU,
                    desc: newItem.Description,
                    type: 'LOW_STOCK',
                    message: 'ירידה למלאי נמוך',
                    priority: 'MEDIUM',
                    details: `מלאי: ${newNet}`
                });
            }

            // 3. Stockout Alert (Was > 0, Now <= 0)
            else if (oldNet > 0 && newNet <= 0) {
                changes.push({
                    sku: newItem.SKU,
                    desc: newItem.Description,
                    type: 'STOCKOUT',
                    message: 'אזל מהמלאי',
                    priority: 'CRITICAL',
                    details: `מלאי: ${newNet}`
                });
            }

            // 4. Classification Change (e.g. B -> A)
            // Only care about upgrades to A or downgrades from A
            if (oldItem.Classification !== newItem.Classification) {
                if (newItem.Classification === 'A') {
                    changes.push({
                        sku: newItem.SKU,
                        desc: newItem.Description,
                        type: 'CLASS_UP',
                        message: 'הפך לפריט A (מוביל)',
                        priority: 'LOW',
                        details: `סיווג קודם: ${oldItem.Classification}`
                    });
                }
            }
        });

        return changes.length > 0 ? changes : null;
    }
};
